// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../db/db-dexie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Estados iniciales
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // Bootstrap auth
    const initSession = () => {
      const storedIsAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
      const jwtToken = localStorage.getItem('JWT');

      if (storedIsAuthenticated && jwtToken) {
        // La sesión está persistida temporalmente
        setAuthenticated(true);
      } else {
        // No hay sesión persistida
        setAuthenticated(false);
      }
      setIsInitializing(false);
    };

    initSession();
  }, []);
  const logInContext = () => {

    // Lógica de autenticación, puede ser una llamada a una API o manejo de tokens
    setAuthenticated(true);
    // Guardar el estado de autenticación en localStorage
    localStorage.setItem('isAuthenticated', 'true');
  };


  const logOutContext = async () => {
    // Limpiar IndexedDB para evitar fugas de roles o sesiones entre logins
    try {
        await db.account.clear();
        await db.subAccount.clear();
        await db.functions.clear();
    } catch (e) {
        console.warn('Error clearing IndexedDB on logout', e);
    }
    
    // Lógica de cierre de sesión, como limpiar tokens o redirigir a la página de inicio de sesión
    setAuthenticated(false);
    // Eliminar el estado de autenticación de localStorage
    localStorage.removeItem('isAuthenticated');
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, isInitializing, logInContext, logOutContext }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
